export const GENERATE_REPORT_TRANSLATION_NAMESPACE = 'generateReport';
export const GLOBAL_TRANSLATION_NAMESPACE = 'global';
export const TEMPLATING_TRANSLATION_NAMESPACE = 'templating';
export const WIDGET_TRANSLATION_NAMESPACE = 'widgets';
export const GLOBAL_WIDGET_NAMESPACE = `${GLOBAL_TRANSLATION_NAMESPACE}:${WIDGET_TRANSLATION_NAMESPACE}`;
export const CHANGE_PASSWORD_TRANSLATION_NAMESPACE = 'changePassword';

export default {
  CHANGE_PASSWORD_TRANSLATION_NAMESPACE,
  GENERATE_REPORT_TRANSLATION_NAMESPACE,
  GLOBAL_TRANSLATION_NAMESPACE,
  GLOBAL_WIDGET_NAMESPACE,
  TEMPLATING_TRANSLATION_NAMESPACE,
};
